import {Component, inject} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {WorkTableService} from './work-table.service';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {ICommonTableAction, ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {MatDialog} from '@angular/material/dialog';
import {WorkEditorComponent} from '../../components/work-editor/work-editor.component';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';
import {filter, switchMap} from 'rxjs';
import {WorkService} from '@lib-services/work.service';
import {MessageService} from '@lib-services/message.service';

@Component({
    selector: 'app-work',
    standalone: true,
    imports: [
        CommonTableComponent,
        LoaderComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './work.component.html',
    styleUrl: './work.component.scss'
})
export class WorkComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН'},
            { name: 'name', title: 'Название работы' },
            { name: 'companyName', title: 'Компания' },
            { name: 'projectName', title: 'Проект' },
        ],
        createButtonLabel: 'Добавить вид работ',
        showCreateButton: true,
        withCheckboxes: true,
        rowActions: [RowAction.DELETE],
    });
    filterConfig: FilterConfig[] = [
        {
            type: 'input',
            label: 'Название работы',
            name: 'name',
        },
        // {
        //     type: 'common-dropdown',
        //     label: 'Компания',
        //     name: 'company.id',
        //     commonDropdownConfig: {
        //         service: inject(CompanySelectorService),
        //         formCtrl: new FormControl(),
        //     },
        // },
    ];

    protected dialog = inject(MatDialog);
    protected workTableService = inject(WorkTableService);
    protected workService = inject(WorkService);
    protected messageService = inject(MessageService);

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ workId: Number(value.data[0]['id']) });
        }
        if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
        if (value.action === RowAction.DELETE) {
            const ids = value.data.map(el => Number(el['id']));
            this.deleteWorks(ids);
        }
    }

    openDialog(data: { workId?: number }): void  {
        this.dialog.open(WorkEditorComponent, {
            width: '50%',
            maxHeight: '330px',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.workTableService.updateData(this.tableConfig);
            }
        });
    };

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.workTableService.updateData(this.tableConfig);
    }

    deleteWorks(ids: number[]): void {
        this.messageService.confirmMessage({
            title: 'Удаление вида(ов) работ',
            text: 'Вы действительно хотите удалить выбранные виды работ?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.workService.deleteWorks(ids);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Виды работ успешно удалены');
                this.workTableService.updateData(this.tableConfig);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }

}
